export default __webpack_public_path__ + "static/media/trr-food-pastry-2.c57bc27d.png";